import { useCapability } from '@/features/permissions/hooks'
import { useEvaluationRubricsRolledOut } from './useEvaluationRubricsRolledOut'

/**
 * Returns whether the signed-in user may open Evaluation Rubrics.
 *
 * The sidebar link's read of the gate. The route does not come through here —
 * it wraps in `ProtectedFeatureRoute` and `ProtectedCapabilityRoute` from the
 * evaluationRubrics entry in `src/config/routeManifest.ts` — so the two must
 * agree on the org-switch guard in `useEvaluationRubricsRolledOut`.
 *
 * Two boundaries, both required: `features.evaluation_rubrics` is the org's
 * rollout control, `config.evaluationRubrics.view` which roles inside it.
 */
export function useEvaluationRubricsEnabled(): boolean {
  const permitted = useCapability('config.evaluationRubrics.view') === true
  const rolledOut = useEvaluationRubricsRolledOut()
  return permitted && rolledOut
}
